// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1fb71","head":"ProcedureTableInfo_head__ZgmfD"};